const MAX_PARENT_TRAVERSAL_FOR_FEEDBACK = 5;

/**
 * @param {string} key
 * @param allowArrays
 * @return {string}
 */
function getSelector(key, allowArrays = false) {

	if (allowArrays) {
		let selector = `input[name='${key}'],select[name='${key}'],textarea[name='${key}']`;

		// Add arrays versions
		selector += `,input[name='${key}[]'],select[name='${key}[]'],textarea[name='${key}[]']`

		return selector;
	} else {
		return `input[name='${key}'],select[name='${key}'],textarea[name='${key}']`;
	}
}

export function fillInputsByName(container, values, allowArrays = false) {
	Object.keys(values).forEach(key => {
		container.querySelectorAll(getSelector(key, allowArrays)).forEach(input => {
			if (
				input.type == 'radio' ||
				input.type == 'checkbox'
			) {
				if (input.value == values[key]) {
					input.checked = true;
				}
			} else {

				input.value = values[key];
			}
		})
	})
}

export function clearInputsByName(container, fields) {
	fields.forEach(field => {
		container.querySelectorAll(getSelector(field)).forEach(input => {
			if (
				input.type == 'radio' ||
				input.type == 'checkbox'
			) {
				input.checked = false;
			} else {

				input.value = '';
			}
		})
	});
}

/**
 * @param container
 * @param fields
 * @param removeFromKeys
 * @return {Object<string,any>}
 */
export function getInputsByName(container, fields, removeFromKeys = []) {
	const values = {};
	fields.forEach(field => {
		container.querySelectorAll(getSelector(field)).forEach(input => {
			if (
				input.type != 'radio' &&
				input.type != 'checkbox'
			) {
				removeFromKeys.forEach(string => {
					field = field.replace(string, '');
				});
				values[field] = input.value;
			}
		})
		if (!values[field]) {
			// Value not found, keep checking
			const checkedElement = container.querySelector(`input[name="${field}"]:checked`);
			if (checkedElement) {
				removeFromKeys.forEach(string => {
					field = field.replace(string, '');
				});
				values[field] = checkedElement.value;
			}
		}
	});

	return values;
}

/**
 * Copy of getInputsByName ^ the only difference is it will return
 * checkbox fields whether they are checked or not, created as a new function
 * because the previous one is used everywhere and for both old and new code
 *
 * @param container
 * @param fields
 * @param removeFromKeys
 * @return {{}}
 */
export function getInputsByNameV2(container, fields, removeFromKeys = []) {
	// noinspection DuplicatedCode
	const values = {};
	fields.forEach(field => {
		let found = false;
		let value = '';
		container.querySelectorAll(getSelector(field)).forEach(input => {
			const inputType = input.type;

			found = true;
			if (inputType === 'checkbox') {
				value = input.checked;
			} else if (inputType === 'radio') {
				// Radio type found
				// Get the selected radio
				// This mean it runs once for each radio button, not efficient
				// but lets keep it simple
				const selectedRadio = document.querySelector(`input[name="${field}"]:checked`);
				if (selectedRadio) {
					value = selectedRadio.value
				} else {
					value = false;
				}
			} else {
				// Treat normally
				value = input.value;
			}
		})

		if (found) {
			removeFromKeys.forEach(string => {
				field = field.replace(string, '');
			});
			values[field] = value;
		}
	});

	return values;
}

/**
 * Removes all feedback from the inputs with the names from fields arguments
 * If fields array is not provided will remove all feedback from container
 *
 * @param {Element} container
 * @param {string[]} [fields]
 */
export function clearFeedbacksByName(container, fields) {
	if (fields) {
		fields.forEach(field => {
			container.querySelectorAll(getSelector(field)).forEach(input => {
				input.classList.remove('is-invalid');

				// Remove related feedback
				const feedbackContainer = findRelatedFeedback(input);
				if (feedbackContainer) {
					feedbackContainer.classList.remove('d-block');
					feedbackContainer.innerHTML = '';
				}
			})
		});
	} else {
		container.querySelectorAll('.is-invalid').forEach(element => {
			element.classList.remove('is-invalid');
		})
		container.querySelectorAll('.invalid-feedback').forEach(feedback => {
			feedback.classList.remove('d-block');
			feedback.innerHTML = '';
		})
	}
}


/**
 * @param {Element} element
 * @return {Element|undefined}
 */
function findRelatedFeedback(element) {
	let parentsTraversed = 1
	while (element.parentElement) {
		if (parentsTraversed > MAX_PARENT_TRAVERSAL_FOR_FEEDBACK) {
			break;
		}
		const feedbackContainer = element.parentElement.querySelector('.invalid-feedback');
		if (feedbackContainer) {
			return feedbackContainer;
		}
		// Not found, get next parent
		element = element.parentElement;
		parentsTraversed++;
	}

	// Feedback container not found
	return undefined;
}
